import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ecdb0c12&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecdb0c12')) {
      api.createRecord('ecdb0c12', component.options)
    } else {
      api.reload('ecdb0c12', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ecdb0c12&", function () {
      api.rerender('ecdb0c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/videoTrial/demo/index.vue"
export default component.exports